import { DotLottieReact } from '@components/lottie/lottie'
import { cn } from '@lib/utils'

export const LottieSwipeHand = ({ className }: { className?: string }) => {
  return (
    <div className={cn('relative', className)}>
      <DotLottieReact
        width={128}
        height={128}
        className='h-full w-full'
        src='/assets/velocity/swipe-left-white.lottie'
        loop
        autoplay
      />
    </div>
  )
}
